import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
import actions from './actions';
import state from './state';
import getters from './getters';
import mutations from './mutations';

export const serviceComputed = {
	...mapGetters('mesCalStore', Object.keys(getters)),
	...mapState('mesCalStore', Object.keys(state))
};
export const serviceMethods = {
	...mapActions('mesCalStore', Object.keys(actions)),
	...mapMutations('mesCalStore', Object.keys(mutations))
};
